export default {
  DEFAULT: 'default',
  DENIED: 'denied',
  GRANTED: 'granted',
  NOT_SUPPORTED: 'not-supported',
}
